<app-header
  [isLocked]="true"
  [displayedPageTitle]="'i18n.search.substitutesPageTitle'"
></app-header>
<ion-content [scrollY]="false">
  <div class="scrolling-element" cdkVirtualScrollingElement>
    <div class="search-layout">
      <ng-container
        *ngIf="!isTouchExperience"
        [ngTemplateOutlet]="SectionToGoBack"
      ></ng-container>
      <app-new-search-skeleton
        *ngIf="!!newSearchViewModel?.loadingState && newSearchViewModel?.loadingState === SearchLoadingState.loading"
      ></app-new-search-skeleton>
      <ng-container
        *ngIf="!!newSearchViewModel?.loadingState &&
        newSearchViewModel?.loadingState !== SearchLoadingState.loading &&
        newSearchViewModel?.loadingState !== SearchLoadingState.error
      "
      >
        <ng-container
          *ngIf="isTouchExperience"
          [ngTemplateOutlet]="SearchResultsHeader"
        ></ng-container>
        <div
          class="search-content"
          [ngClass]="{'desktop': isTouchExperience === false}"
        >
          <div class="search-results">
            <ng-container
              *ngIf="!isTouchExperience"
              [ngTemplateOutlet]="SearchResultsHeader"
            ></ng-container>
            <div class="mobile-replacement-section">
              <ng-container
                *ngTemplateOutlet="OriginalItem;context:{$implicit:{replacementBaseProduct: replacementBaseProduct}}"
              >
              </ng-container>
            </div>
            <div class="desktop-tablet-replacement-section">
              <ng-container
                *ngTemplateOutlet="OriginalItem;context:{$implicit:{replacementBaseProduct: replacementBaseProduct}}"
              >
              </ng-container>
            </div>
            <h2 *ngIf="substitutionType" data-cy="search-result-page-mode-text">
              {{ substitutionType === 'substituteSearch' || substitutionType ===
              'exceptionSearch' ?
              ('i18n.orderExceptionsPage.uSFoodsSuggestedSubstitutes' |
              translate) :
              ('i18n.orderExceptionsPage.uSFoodsSuggestedReplacements' |
              translate) }}
            </h2>
            <app-new-search-result
              [pwrRatingStarsMap]="pwrRatingStarsMap | async"
              [newSearchViewModel]="newSearchViewModel"
              [replacementBaseProduct]="replacementBaseProduct"
              (selectionChange)="handleSelectedProducts($event)"
              [isMultiSelectionEnabled]="selection === SelectionType.CompareProducts"
              [isTouchExperience]="isTouchExperience"
              [itemsSelectable]="!!selection"
              [itemHeights]="itemHeights"
              (scrolledIndexChange)="nextBatch($event)"
            ></app-new-search-result>
            <section
              *ngIf="newSearchViewModel?.loadingState === SearchLoadingState.loadingNextPage"
              class="new-search-result-skeleton-wrapper"
            >
              <ion-skeleton-text class="item"></ion-skeleton-text>
              <ion-skeleton-text class="item"></ion-skeleton-text>
              <ion-skeleton-text class="item"></ion-skeleton-text>
              <ion-skeleton-text class="item"></ion-skeleton-text>
            </section>
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="!!newSearchViewModel?.loadingState &&
        newSearchViewModel?.loadingState === SearchLoadingState.error"
      >
        <div class="search-error">
          <app-message-bar
            [isMobile]="false"
            [shouldDisplay]="true"
            [radius]="8"
            [textAlign]="'left'"
            [paddingX]="20"
            [paddingY]="14"
          >
            <div class="error-message">
              <ion-icon name="alert-circle-outline"> </ion-icon>
              <p>
                {{ isTouchExperience ? ('i18n.search.messageBarTouch' |
                translate) : ('i18n.search.messageBarNotTouch' | translate) }}
              </p>
            </div>
          </app-message-bar>
        </div>
      </ng-container>
    </div>
    <app-footer></app-footer>
  </div>

  <div class="sticky-action-bar-container">
    <app-search-top-button
      class="top-button"
      [isMobile]="this.platformService.platformType === platformService.platformEnum.mobile"
      [class.selected-products]="selectedProducts?.length > 0"
      [class.mobile]="this.platformService.platformType === platformService.platformEnum.mobile"
      [class.tablet]="this.platformService.platformType === platformService.platformEnum.tablet"
      (scrollToTop)="scrollToTop()"
    ></app-search-top-button>
    <app-mobile-search-operations
      *ngIf="(!!newSearchViewModel?.facetLoadingState &&
      newSearchViewModel?.facetLoadingState !== SearchLoadingState.loading &&
      newSearchViewModel?.facetLoadingState !== SearchLoadingState.error) &&
      platformService?.platformType === platformService?.platformEnum?.mobile"
      [selection]="selection"
      [isGuestUser]="isGuestUser"
      [showInventory]="showInventory && !isAddToList"
      [isAddToList]="isAddToList"
      [isInventory]="isInventory"
      (selectionChange)="handleSelectionTypeChange($event)"
      class="sticky-operations"
    ></app-mobile-search-operations>
    <app-sticky-action-bar
      *ngIf="
          selectedProducts?.length >= 2 &&
          selection === SelectionType.CompareProducts
        "
      [selectionCount]="selectedProducts?.length"
      [selectionCountText]="'Compare ' + selectedProducts?.length + ' of 4'"
      [primaryButtonText]="'i18n.search.compare' | translate"
      [isPrimaryButtonDisabled]="selectedProducts?.length < 2"
      dataCy="compare-products-subs"
      (clearSelection)="clearSelectedProducts()"
      (primaryAction)="redirectToComparePage()"
    ></app-sticky-action-bar>

    <app-sticky-action-bar
      *ngIf="
          selectedProducts?.length > 0 &&
          selection === SelectionType.AddToList
        "
      [selectionCountText]="selectedProductText"
      [selectionCount]="selectedProducts?.length"
      [primaryButtonText]="footerActionText"
      dataCy="add-to-list-subs"
      (clearSelection)="clearSelectedProducts()"
      (primaryAction)="openActionModal()"
    ></app-sticky-action-bar>
  </div>

  <ion-modal
    [isOpen]="this.addToListModalService.isModalOpen$ | async"
    (ionModalDidDismiss)="closeAndDeatachAddToListModal()"
    [class]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch'
      : 'modal-desktop-size-xl'
  "
    [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
    [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
    id="addToListModal"
  >
    <ng-template>
      <app-modal-with-nav-inline
        [rootPage]="this.addToListModalService.dualPaneRef"
        [rootPageParams]="this.addToListModalService.dualPaneModalData"
      >
      </app-modal-with-nav-inline>
    </ng-template>
  </ion-modal>
</ion-content>
<ng-template #SearchResultsHeader>
  <div
    class="search-results-header"
    [ngClass]="isTouchExperience ?
  platformService?.platformType === platformService?.platformEnum?.tablet ?
    'tablet' :
    'mobile' :
    'desktop'
  "
  >
    <ng-container *ngTemplateOutlet="SearchResultsText;"></ng-container>
    <ng-container *ngTemplateOutlet="FacetContainer;"></ng-container>
    <div class="search-container">
      <app-new-search-operations
        *ngIf="platformService?.platformType !== platformService?.platformEnum.mobile && (newSearchViewModel?.totalCount > 0 || hasFacetsApplied)"
        [selection]="selection"
        [SelectionType]="SelectionType"
        (compareProducts)="handleSelectionTypeChange($event)"
        [isGuestUser]="isGuestUser"
        [showAddToList]="shouldDisplayAddToList"
      >
      </app-new-search-operations>
      <app-new-search-facet-pills
        class="search-header-facet-pills"
        [facetChipViewModels]="actionBarFacetChipViewModels"
        [showOverflowButton]="true"
        (additionalFacetsClick)="openFacetFlyout()"
        *ngIf="actionBarFacetChipViewModels.length > 0"
      ></app-new-search-facet-pills>
    </div>
  </div>
</ng-template>

<ng-template #SearchResultsText>
  <div class="search-results-text">
    <h2 class="search-text">
      <span
        *ngIf="platformService?.platformType !== platformService?.platformEnum?.mobile && !!newSearchViewModel?.searchText"
        class="shop-text header-text"
      >
        {{headerText | uppercase}}
      </span>
      <ng-container
        *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
      >
        “{{ newSearchViewModel?.searchText ?? 'i18n.search.allProducts' |
        translate | uppercase}}
      </ng-container>
      <ng-container
        *ngIf="platformService?.platformType !== platformService?.platformEnum?.desktop"
      >
        “{{ newSearchViewModel?.searchText ?? 'i18n.search.allProducts' |
        translate | acronymTitleCase}}
      </ng-container>
    </h2>
    <!-- we don't want the quotation mark to be truncated, use h2 and the .search-text to keep the same style -->
    <h2 class="quotation-mark">”</h2>
    <span class="header-text">
      ({{ newSearchViewModel?.totalCount > 999 ? '999+' :
      newSearchViewModel?.totalCount }} Results)
    </span>
    <app-new-search-bar
      *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
      class="search-bar"
      (handleSearch)="handleInPageSearch($event)"
    ></app-new-search-bar>
    <ion-icon
      *ngIf="platformService?.platformType !== platformService?.platformEnum?.desktop"
      class="search-icon"
      (click)="onSearchIconClick()"
      name="search-outline"
    ></ion-icon>
  </div>
</ng-template>
<app-new-search-simple-modal
  [isOpen]="isInPageSearchModalOpen"
  (executeSearchEmitter)="handleInPageSearchModalEvent($event)"
></app-new-search-simple-modal>

<ng-template #FacetContainer>
  <app-new-search-actions
    *ngIf="newSearchViewModel?.totalCount !== 0"
    [facets]="actionBarFacets"
    [usfDeliveredFacetValue]="usfDeliveredFacetValue"
    [deliveryTypeFacet]="deliveryFacet"
    [ourExclusivesFacet]="ourExclusivesFacet"
    (allFiltersPressed)="openFacetFlyout()"
    (facetButtonPressed)="openFacetFlyout($event)"
    [isMobile]="this.platformService.getPlatformType() === platformService.platformEnum.mobile"
    (facetsSelected)="onFacetsSelected($event)"
  ></app-new-search-actions>
</ng-template>

<app-facet-flyout-container
  [facetFlyoutTitle]="'i18n.search.allFilters'"
  [platformType]="platformService.getPlatformType()"
  [facets]="flyoutFacets"
  [facetChipViewModels]="facetChipViewModels"
  [isLoading]="coveoSearch?.state?.isLoading && !isLoadingFacetValues"
  (facetsSelected)="onFacetsSelected($event)"
  (clearAll)="clearAllFacets()"
  (facetLoadValues)="facetLoadValues($event)"
></app-facet-flyout-container>

<ng-template #OriginalItem let-data>
  <h2>Original Product</h2>
  <app-selectable-search-result
    *ngIf="replacementBaseProduct"
    [replacementProduct]="replacementBaseProduct"
    [product]="replacementBaseProduct"
    [isTouchExperience]="isTouchExperience"
    [isHideQuantity]="false"
    [selectable]="selection === SelectionType.CompareProducts"
    [overrideModeCheck]="true"
  >
  </app-selectable-search-result>
</ng-template>

<ng-template #SectionToGoBack>
  <div
    class="back-button-container"
    *ngIf="platformService?.platformType === platformService?.platformEnum.desktop"
  >
    <app-back-button [backButtonText]="backButtonText"></app-back-button>
  </div>
</ng-template>
